import validarCPF from 'validar-cpf';
import { z } from 'zod';

const emailAcesso = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const cpfAcesso = z
  .string()
  .trim()
  .min(1, 'CPF é obrigatório')
  .refine((value) => validarCPF(value), { message: 'CPF inválido!' });

export const loginSchema = z.object({
  cpf: cpfAcesso,
  senha: z.string().min(1, 'Senha é obrigatória'),
});

export const forgotPasswordSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, 'Email é obrigatório')
    .refine((value) => emailAcesso.test(value), { message: 'Email inválido!' }),
  cpf: cpfAcesso,
});

export const resetPasswordSchema = z
  .object({
    cpf: cpfAcesso,
    code: z.string().trim().min(1, 'Código de verificação é obrigatório!'),
    newPassword: z
      .string()
      .min(1, 'Senha é obrigatória!')
      .min(6, 'A senha deve ter no mínimo 6 caracteres!'),
    confirmNewPassword: z.string().min(1, 'Confirmação de senha é obrigatória!'),
  })
  .refine((data) => data.newPassword === data.confirmNewPassword, {
    message: 'As senhas não coincidem!',
    path: ['confirmNewPassword'],
  });
